import { StatusBadge } from '../../components/StatusBadge';
import {
  formatRetention,
  recordingErrorLabels,
  recordingPausedHints,
  recordingView,
  scheduleSummary,
  type PolicySummary,
} from './api';

/** Recording column of the device list: state, recorded profile, retention. */
export function RecordingCell({ policy }: { policy: PolicySummary | undefined }) {
  if (!policy?.enabled) return <StatusBadge tone="neutral">Desligada</StatusBadge>;
  const v = recordingView(policy);
  const profile =
    policy.profile_name || (policy.profile_token === '' ? 'Principal' : policy.profile_token);
  return (
    <div>
      <span
        title={
          policy.state === 'error' && policy.last_error
            ? recordingErrorLabels[policy.last_error]
            : (recordingPausedHints[policy.state] ??
              (policy.mode === 'schedule'
                ? `Agenda: ${scheduleSummary(policy.schedule)}`
                : undefined))
        }
      >
        <StatusBadge tone={v.tone} pulse={policy.state === 'recording'}>
          {v.label}
        </StatusBadge>
      </span>
      <div className="mt-0.5 text-2xs text-fg-subtle">
        {profile} · {formatRetention(policy.retention_minutes)}
        {policy.mode === 'schedule' && ' · por agenda'}
        {policy.mode === 'event' && ' · por evento'}
      </div>
    </div>
  );
}
